import { render, staticRenderFns } from "./AddMakeupClassSingleModal.vue?vue&type=template&id=5eaa5768&scoped=true&"
import script from "./AddMakeupClassSingleModal.vue?vue&type=script&lang=js&"
export * from "./AddMakeupClassSingleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaa5768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eaa5768')) {
      api.createRecord('5eaa5768', component.options)
    } else {
      api.reload('5eaa5768', component.options)
    }
    module.hot.accept("./AddMakeupClassSingleModal.vue?vue&type=template&id=5eaa5768&scoped=true&", function () {
      api.rerender('5eaa5768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/AddMakeupClassSingleModal.vue"
export default component.exports